'use client';
import React, { useState } from 'react';
import AppLayout from '@/components/AppLayout';
import AdminDashboardContent from './components/AdminDashboardContent';

export default function AdminDashboardPage() {
  return (
    <AppLayout activePath="/admin">
      <AdminDashboardContent />
    </AppLayout>
  );
}
